import React, { createContext, useState } from 'react';

export const SessionContext = createContext();

export const SessionProvider = ({ children }) => {
 // Initialize session with a default currency (e.g., "eur")
 const [session, setSession] = useState({ currency: 'eur' });

  return (
    <SessionContext.Provider value={{ session, setSession }}>
      {children}
    </SessionContext.Provider>
  );
};